module.exports = __webpack_public_path__ + "img/auth-阿虎医考-授权书铜牌.54453e7e.png";